import { ACTIVE_APP_ENVIRONMENT, canSelectAppEnvironment, isAppEnvironment, saveAppEnvironment, type AppEnvironment } from "@/lib/appEnvironment"
import { isNativeApp } from "@/lib/platform"
import { clearNativeEnvironmentSession, token } from "@/lib/tokenStore"

export async function switchAppEnvironment(environment: AppEnvironment): Promise<void> {
  if (!isNativeApp()) throw new Error("A troca de ambiente está disponível apenas no aplicativo.")
  if (!canSelectAppEnvironment()) throw new Error("A seleção de ambiente está desativada neste aplicativo.")
  if (!isAppEnvironment(environment)) throw new Error("Ambiente inválido.")
  if (environment === ACTIVE_APP_ENVIRONMENT) return

  await clearNativeEnvironmentSession(environment)
  // Persist only after clearing the destination successfully. Until the reload,
  // API clients and offline databases retain the source environment snapshot.
  saveAppEnvironment(environment)
  token.clear()
  // Reload the complete WebView, not just a Next.js route: recreates every client,
  // store and realtime connection against the selected API before authentication.
  window.location.replace("/")
}
